// extracted by mini-css-extract-plugin
module.exports = {"custom_form_card":"form_custom_form_card__39gRA"};